module.exports = __webpack_public_path__ + "img/slider_button.svg";